import { AppState } from "..";
import { AuthState } from "./slice";

function data(state: AppState): AuthState {
  return state.auth;
}

function isLoading(state: AppState): boolean {
  return state.auth.isLoading;
}

function isLoggedIn(state: AppState): boolean {
  return state.auth.isLoggedIn;
}

function accessToken(state: AppState) {
  return state.auth.accessToken;
}

function deal(state: AppState, dealId: string) {
  if (!state.auth.account || !state.auth.account.deals) {
    return undefined;
  }

  return state.auth.account.deals.find((c) => c.id === dealId);
}

function dealLastSeen(state: AppState, dealId: string): number | undefined {
  if (!state.auth.dealsLastSeen[dealId]) {
    return undefined;
  }

  return state.auth.dealsLastSeen[dealId];
}

function dealsLastSeen(state: AppState): Record<string, number> {
  return state.auth.dealsLastSeen;
}

function actor(state: AppState) {
  return state.auth.actor;
}

function account(state: AppState) {
  return state.auth.account;
}

function activeDealId(state: AppState) {
  return state.auth.activeDealId;
}

function navigationCollapsed(state: AppState) {
  return state.auth.navigationCollapsed;
}

// hack hack hack
function staffSheetQuestionAnswer(state: AppState) {
  return state.auth.staffSheetQuestionAnswer;
}

export const authSelectors = {
  data,
  isLoading,
  isLoggedIn,
  accessToken,
  deal,
  actor,
  account,
  dealLastSeen,
  dealsLastSeen,
  navigationCollapsed,

  // hack hack hack
  staffSheetQuestionAnswer,
  activeDealId,
};
